/**
 *   Generated file. Do not edit
 */

import { DataLogOption } from './models';
import { SinglePacket } from '@iotize/tap/service/impl/single-packet';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

import { singlePacketConverters } from '@iotize/tap/service/impl/single-packet';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,

  ...singlePacketConverters,
};

export const SERVICE_CALLS = {
  getMaxPacketCount: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/data-log/max-packet-count',
    path: '/1024//23',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  isRunning: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/data-log/run',
    path: '/1031//0',
    responseBodyDecoder: allConverters.boolean,
  } as ServiceCallType<void, boolean>,

  run: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/data-log/run',
    path: '/1031//0',
  } as ServiceCallType<void, void>,

  stop: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/data-log/stop',
    path: '/1031//1',
  } as ServiceCallType<void, void>,

  getOptions: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/data-log/options',
    path: '/1031//2',
    responseBodyDecoder: allConverters.dataLogOption,
  } as ServiceCallType<void, DataLogOption>,

  putOptions: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/data-log/options',
    path: '/1031//2',
    bodyEncoder: allConverters.dataLogOption,
  } as ServiceCallType<DataLogOption, void>,

  putCryptoKey: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/data-log/crypto-key',
    path: '/1031//3',
  } as ServiceCallType<Uint8Array, void>,

  flush: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/data-log/flush',
    path: '/1031//4',
  } as ServiceCallType<void, void>,

  getPacketCount: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/data-log/packet-count',
    path: '/1031//10',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  dequeueOnePacket: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/data-log/dequeue-packet',
    path: '/1031//11',
    responseBodyDecoder: allConverters.singlePacket,
  } as ServiceCallType<void, SinglePacket>,
};
